import Loader from '@bharatpe/bharat-ui/web/Loader';
import { makeStyles } from '@bharatpe/bharat-ui/web/Styles';
import React, { useEffect } from 'react';
import { triggerJuspayPaymentModesApi, JuspayPaymentModesSlice, useJuspayPaymentModes } from 'Slices';
import { useDispatch } from 'react-redux';
import { showPostPeUI, showTwelvePcUI, showZillionUi } from 'utils/Utils';
import LoaderNew from 'components/atoms/Loader';
import { getURLParameter, showPostpeLoader } from 'utils/nativeSupport';
import { registerSlice } from 'store';
import { useHistory, useParams } from 'react-router-dom';

registerSlice(JuspayPaymentModesSlice);

const useStyle = makeStyles(() => ({
	mainContainer: {
		background: '#ffffff',
		height: '100vh',
	},
}));

declare global {
	interface Window {
		callbackHyperSdkInit: any;
		callbackHyperSdkPaymentSuccess: any;
		callbackHyperSdkPaymentError: any;
		callbackHyperSdkInitStatus: any;
		callbackMufinPaySuccess: any;
		callbackMufinPayError: any;
	}
}

const BharatPeXLandingPage: React.FC = () => {
	const isShowTwelvePcUI = showTwelvePcUI();
	const isShowPostPeUI = showPostPeUI();
	const isShowZillionUi = showZillionUi();
	const classes = useStyle();
	const dispatch = useDispatch();
	const history = useHistory();
	const juspayPaymentModesData = useJuspayPaymentModes();
	const checkout = getURLParameter(window.location.href, 'checkout') || '';
	const params: any = useParams();

	useEffect(() => {
		if (params?.pageSource === 'consumer') {
			dispatch(triggerJuspayPaymentModesApi({ checkout }));
		}
	}, [params]);

	useEffect(() => {
		if (juspayPaymentModesData?.data?.payloads?.bpx) {
			if (isShowPostPeUI)
				showPostpeLoader({ first_message: 'loading', start_index: 0, range: 7, second_message: 'please wait' });
			initialiseBPXTransaction(juspayPaymentModesData?.data?.payloads);
		}
	}, [juspayPaymentModesData?.data?.payloads, isShowPostPeUI, dispatch]);

	const initialiseBPXTransaction = async (bpXPayload: any) => {
		const parsedPayload = JSON.parse(bpXPayload?.bpx);

		const nativeData = {
			key: 222,
			payload: parsedPayload,
		};
		console.log('nativeData', nativeData);

		console.log('===================callbackBPXHyperSdkInit status payload======================');

		await window.androidObj.nativeSupport(JSON.stringify(nativeData));

		window.callbackMufinPaySuccess = (jsonString: any) => {
			console.log('===================callbackBPXHyperSdkPaymentSuccess status======================', jsonString);
			history.push('/thanks');
		};

		window.callbackMufinPayError = (jsonString: any) => {
			//redirect here
			console.log('===================callbackBPXHyperSdkPaymentError status======================', jsonString);
			history.push('/thanks');
		};

		// processBPXPayment(bpXPayload);
	};

	const processBPXPayment = async (bpXPayload: any) => {
		const parsedExternalPgPayload = JSON.parse(bpXPayload?.process);
		const parsedDeeplink = bpXPayload?.microViewDeepLink;
		const nativeData = {
			key: 102,
			payload: parsedExternalPgPayload,
			deeplink: parsedDeeplink,
		};
		console.log('===================callbackBPXHyperSdkPaymentSuccess payload======================');
		await window.androidObj.nativeSupport(JSON.stringify(nativeData));

		window.callbackHyperSdkPaymentSuccess = (jsonString: any) => {
			console.log('===================callbackBPXHyperSdkPaymentSuccess status======================', jsonString);
			history.push('/thanks');
		};

		window.callbackHyperSdkPaymentError = (jsonString: any) => {
			//redirect here
			console.log('===================callbackBPXHyperSdkPaymentError status======================', jsonString);
			history.push('/thanks');
		};
	};

	useEffect(() => {
		if (!isShowPostPeUI) return;

		showPostpeLoader({ first_message: 'loading', start_index: 0, range: 7, second_message: 'please wait' });
	}, [isShowPostPeUI]);

	return (
		<div className={isShowTwelvePcUI || isShowPostPeUI ? classes.mainContainer : ''}>
			{!isShowPostPeUI &&
				(isShowTwelvePcUI || isShowZillionUi ? (
					<LoaderNew loading loaderType={isShowTwelvePcUI ? '12pc' : 'zillion'} />
				) : (
					<Loader loading />
				))}
		</div>
	);
};

export default BharatPeXLandingPage;
